import React from 'react';

const BooleanOutput = ({ value }) => (
  <span className="icon">
    <i className={`fas ${value === true ? 'fa-check' : ''}`} />
  </span>
);

export default BooleanOutput;
